import { getCountryAlpha2, isValidPostalCode } from "@nemuru-eng/js-api-client";

export const postalCodeValidation = (country, postalCode) => {
  if (!country || !postalCode) return true;
  const countryAlpha2 =
    country.length === 3 ? getCountryAlpha2(country) : country;
  try {
    return isValidPostalCode(postalCode, countryAlpha2);
  } catch (error) {
    if (error.message.includes("not supported for postal code validation")) {
      return true;
    }
    throw new Error();
  }
};
